module.exports = __webpack_public_path__ + "img/cirrus.501b5492.png";